<script>
    import Icon from '../../../components/Icon.svelte';
    import Modal from '../../../components/Modal.svelte';
    import AudioPlayer from '../../../components/AudioPlayer.svelte';
    import sessionStore from 'store/session';
    import InfiniteScroll from 'svelte-infinite-scroll';
    import { getContactName } from '../../../common/utils.js';
    import { getNextPageCallLogAction } from 'domain/session/callLog.actions';
    import userStore from 'store/user';

    let showNoteModal = false;
    let showRecordingModal = false;
    let activeItem = {};
    let mobileID;

    let calls = [];

    userStore.subscribe((value) => {
        mobileID = value.mobileID;
    });

    const groupByDate = (calls) => {
        const groupedCalls = calls.reduce((acc, call) => {
            const date = new Date(call.start_time).toDateString();
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(call);
            return acc;
        }, {});

        return Object.entries(groupedCalls).map(([date, calls]) => ({
            date,
            calls,
        }));
    };

    sessionStore.subscribe((session) => {
        let grouped_calls = groupByDate(session.calls.results);

        calls = { ...session.calls, results: grouped_calls };
    });

    const formatDuration = (duration) => {
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    let page = 1;

    const fetchData = async () => {
        await getNextPageCallLogAction(mobileID, page);
    };
</script>

<div id="call-history-logs">
    <div class="row tab-content">
        {#each calls.results as log}
            <p class="text-left w-100 date font-400 mt-0">{log.date}</p>
            <ul class="call-logs">
                {#each log.calls as item}
                    <li class="padding-10">
                        <div class="call-icon mr-10">
                            <Icon
                                icon={item.is_missed_call
                                    ? 'missed-call'
                                    : item.is_dialed
                                    ? 'outgoing-call'
                                    : 'incoming-call'}
                            />
                        </div>
                        <div class="call-detail font-700">
                            <p class="m-0 font-700">{item.recipient_number}</p>
                            <p class="d-flex m-0 font-400">
                                <span class="padding-right-10 mr-10"
                                    >{getContactName(item.recipient_number)}</span
                                >
                                <!-- <span
                                    class="padding-right-10 font-400 mr-10"
                                    on:click={() => {
                                        showNoteModal = true;
                                        activeItem = item;
                                    }}
                                >
                                    <a href="#" class="view-note">
                                        <div><Icon icon="note" size="16" /></div>
                                        View
                                    </a>
                                </span> -->
                                <span
                                    class="padding-right-10 font-400"
                                    on:click={() => {
                                        activeItem = item;
                                        showRecordingModal = true;
                                    }}
                                >
                                    <a href="#" class="play-recording">
                                        <div><Icon icon="play-circle" size="16" /></div>
                                        Play
                                    </a>
                                </span>
                            </p>
                        </div>
                        <div class="call-time">
                            <p class="m-0 font-700 text-right">
                                {formatDuration(item.duration_secs) || '--:--:--'}
                            </p>
                            <p class="m-0 font-400 text-right time">
                                {new Date(item.date_created).toLocaleTimeString()}
                            </p>
                        </div>
                    </li>
                {/each}
            </ul>
        {/each}
        <InfiniteScroll
            hasMore={calls.next !== null}
            threshold={5}
            on:loadMore={() => {
                page++;
                fetchData();
            }}
        />
    </div>

    {#if showNoteModal}
        <Modal onClose={() => (showNoteModal = false)} title={activeItem?.recipient_number}>
            <p>
                {activeItem.note?.note || 'No note attached'}
            </p>
        </Modal>
    {/if}

    {#if showRecordingModal}
        <Modal onClose={() => (showRecordingModal = false)} title={activeItem?.recipient_number}>
            <div class="popup-calls">
                <ul class="calls-ul">
                    <li class="padding-10">
                        <AudioPlayer sourceURL={activeItem?.recording} />

                        <div class="d-flex popup-call">
                            <div class="left">
                                <p class="m-0 font-700">Call from: {activeItem?.recipient_number}</p>
                            </div>
                            <div class="right">
                                <p class="m-0 font-400 text-right time-color">
                                    {new Date(activeItem?.date_created).toLocaleTimeString()}
                                    <Icon icon="keyboard-arrow-up" />
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </Modal>
    {/if}
</div>

<style lang="scss">
    #call-history-logs {
        .tab-content {
            padding: 0 0.75rem !important;
            display: block;
            max-height: 392px;
            overflow-y: scroll;
            ul.call-logs {
                list-style: none;
                margin: 0px !important;
                padding: 0px !important;
                li {
                    display: flex;
                    border: 1px solid rgba(17, 54, 69, 0.05);
                    border-radius: 12px;
                    width: 100%;
                    margin-bottom: 10px;
                    padding: 10px 16px;
                    .left {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        input {
                            width: 90%;
                            height: 5px;
                        }
                    }
                    .call-time {
                        color: #111;
                    }
                    .call-detail {
                        flex: 1;
                        .view-note,
                        .play-recording {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            div {
                                margin-right: 4px;
                                display: flex;
                            }
                        }
                    }
                    .call-time {
                        p {
                            padding: 0px !important;
                            color: #474b50;
                            font-weight: 600;
                            font-size: 12px;
                        }
                        p.time {
                            color: #a7b4be;
                            font-weight: 500;
                            font-size: 12px;
                        }
                    }
                }
            }
            p {
                line-height: 1.5;
                font-size: 14px;
                span {
                    border-right: 1px solid #eeeeee;
                    font-size: 12px;
                    color: #616c74;
                }
                span:last-child {
                    border-right: 0px !important;
                }
            }
            .date {
                font-size: 14px;
                color: #607d8a;
            }
        }

        .tab-content::-webkit-scrollbar {
            display: none;
        }

        .popup-calls {
            .calls-ul {
                margin-top: 0px;
                padding: 0;
                list-style: none;
                li {
                    flex-direction: column;
                    background: #ffffff;
                    border: 1px solid rgba(17, 54, 69, 0.05);
                    border-radius: 12px;
                    padding: 17px;
                    margin-bottom: 8px;
                }
                .right {
                    p {
                        display: flex;
                    }
                }
                .left {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    input {
                        width: 90%;
                        height: 5px;
                    }
                }
                .popup-call {
                    p {
                        font-size: 14px;
                    }
                }
                .time-color {
                    color: #a7b4be !important;
                }
                .range-main {
                    height: 5px;
                    background: #d9e2e7;
                    border-radius: 8px;
                    margin: 0 10px;
                    overflow: visible;
                    width: 100%;
                    .range {
                        background-color: #f3bf24;
                        height: 5px;
                        max-height: 8px;
                        width: 50%;
                        position: relative;
                        border-radius: 5px;
                    }
                    span {
                        background-color: #f3bf24;
                        float: right;
                        position: absolute;
                        right: -5px;
                        top: -5px;
                        width: 14px;
                        height: 14px;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
</style>
